import ManagePermanent from '../../../views/Personnel/Letter/ManagePermanent.letter.view';

export default ManagePermanent;
